import React, { Component } from "react";

export default class LearningMethod extends Component {
  render() {
    return (
      <div className="feature-section">
        <div className="learning-method-section ">
          <div className="container py-5">
            <div className="text-center">
              <h3 className="text-uppercase">Learning Methodology</h3>

              <div className="row m-0 pt-5">
                <div className="col-md-3">
                  <div className="icon mb-3">
                    <img
                      src="./images/homepage/exam.png"
                      style={{ width: "50%" }}
                      alt=""
                    />
                  </div>
                  <div className="text">
                    <h4>Blended Learning</h4>
                    <p>
                      Ability to combine classroom learning with online learning
                      and conduct live video sessions at scheduled times
                    </p>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="icon mb-3">
                    <img
                      src="./images/homepage/game-pad.png"
                      style={{ width: "50%" }}
                      alt=""
                    />
                  </div>
                  <div className="text">
                    <h4>Gamification</h4>
                    <p>
                      Ability to add basic gamification by assigning actions
                      points, badges and have leaderboards
                    </p>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="icon mb-3">
                    <img
                      src="./images/homepage/degree.png"
                      style={{ width: "50%" }}
                      alt=""
                    />
                  </div>
                  <div className="text">
                    <h4>Certification</h4>
                    <p>
                      Setup certification for your own academy with your logo ,
                      theme
                    </p>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="icon mb-3">
                    <img
                      src="./images/homepage/conversation.png"
                      style={{ width: "50%" }}
                      alt=""
                    />
                  </div>
                  <div className="text">
                    <h4>Communication </h4>
                    <p>
                      Facility to setup discussion boards, time tables and chat
                      options Sell your courses and subscriptions online via the
                      site
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="row m-0">
            <div className="col-md-6 d-flex flex-column justify-content-center align-items-center">
              <div>
                <h4 className="mb-3 text-primary text-uppercase">Reporting </h4>
                <p>
                  <i className="fa fa-circle text-primary"></i> Keep track of
                  who uses the system via an interactive timeline
                </p>

                <p>
                  <i className="fa fa-circle text-primary"></i> Detailed report
                  generation based on different criterias
                </p>
              </div>
            </div>
            <div className="col-md-6 background report-background"></div>
            <div className="col-md-6  background security-background"></div>
            <div className="col-md-6  d-flex flex-column justify-content-center align-items-center">
              <div>
                <h4 className="mb-3 text-primary text-uppercase">Security </h4>
                <p>
                  <i className="fa fa-circle text-primary"></i> Secure protocols
                  with https
                </p>

                <p>
                  <i className="fa fa-circle text-primary"></i> Strong password
                  protection
                </p>
                <p>
                  <i className="fa fa-circle text-primary"></i> Data integrity
                  ensured
                </p>
                <p>
                  <i className="fa fa-circle text-primary"></i> GDPR compliance
                  and privacy protection
                </p>
                <p className="m-0">
                  <i className="fa fa-circle text-primary"></i> Amazon cloud
                  architecture
                </p>
              </div>
            </div>

            <div className="col-md-6 d-flex flex-column justify-content-center align-items-center">
              <div>
                <h4 className="mb-3 text-primary text-uppercase">
                  Customisation{" "}
                </h4>
                <p>
                  <i className="fa fa-circle text-primary"></i> Customise the
                  landing page
                </p>

                <p>
                  <i className="fa fa-circle text-primary"></i> Use own logo and
                  text
                </p>
                <p>
                  <i className="fa fa-circle text-primary"></i> Sleep user
                  interface and responsive design
                </p>
                <p>
                  <i className="fa fa-circle text-primary"></i> View on any
                  device
                </p>
                <p className="m-0">
                  <i className="fa fa-circle text-primary"></i> Multilingual
                </p>
              </div>
            </div>
            <div className="col-md-6 background customisation-background"></div>
          </div>
        </div>
      </div>
    );
  }
}
